module.exports = __webpack_public_path__ + "img/logo_user.e558addf.png";